<template>
  <div>
    <el-form label-width="120px" :model="editForm" :rules="rules" ref="editForm" :disabled="onlyView">
      <el-row :gutter="50">
        <el-col :span="24">
          <el-form-item label="姓名" prop="name">
            <el-input v-model="editForm.name" auto-complete="off" placeholder="请输入姓名"
                      maxlength="50"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="联系电话" prop="mobile">
            <el-input v-model="editForm.mobile" auto-complete="off" placeholder="请输入联系电话"
                      maxlength="11"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="邮箱" prop="mailBox">
            <el-input type="textarea" v-model="editForm.mailBox" auto-complete="off" placeholder="请输入邮箱"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="是否默认联系人" prop="isDef">
            <el-radio-group v-model="editForm.isDef">
              <el-radio :label="0">是</el-radio>
              <el-radio :label="1">否</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import _ from 'lodash'
import { getInfo } from '@/api/user/userContact'
export default {
  data () {
    return {
      // rules表单验证
      rules: {
        name: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        mobile: [{ required: true, message: '请输入电话号码', trigger: 'blur' },
          {
            pattern: /^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[89])\d{8}$/,
            message: '请输入正确的电话号码'
          }],
        isDef: [{ required: true, message: '请选择是否默认', trigger: 'blur' }]
      },
      editForm: {
      },
      inputVisible: false,
      inputValue: '',
      onlyView: false,
      type: ''
    }
  },
  props: ['edit'],
  mounted () {
    this.editForm = _.cloneDeep(this.edit)
    this.type = this.editForm.pageType
    // if (this.editForm.pageType === 'edit' || this.editForm.pageType === 'view') {
    //   this.getDetail()
    // }
    if (this.editForm.pageType === 'view') {
      this.onlyView = true
    }
  },
  methods: {
    getDetail () {
      getInfo(this.editForm).then(res => {
        var result = res.data
        if (result.rtnCode !== '0') {
          this.$message({
            type: 'info',
            message: result.msg
          })
        } else {
          this.editForm = result.bizData
          this.editForm.pageType = this.type
        }
      }).catch(ex => {
        this.loading = false
        this.$message.error('获取详情失败，请稍后再试！')
      })
    }
  }
}
</script>
